module.exports = __webpack_public_path__ + "assets/189fc51a0f2d3c0346ada6f14f5eb1c6.png";